import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { showError, loginWithSiteAppId } from "../../redux/common/actions";
import ConfirmDialog from 'components/Elements/ConfirmDialog';

export const withSiteAppSwitching = (WrappedComponent) => {
    return function WithSiteAppSwitchingComponent(props) {
        const dispatch = useDispatch();
        const [showSwitchDialog, setShowSwitchDialog] = useState(false);
        const [targetSiteAppId, setTargetSiteAppId] = useState(null);

        // Get user data from storage
        const userData = JSON.parse(localStorage.getItem("me")) ||
            JSON.parse(sessionStorage.getItem("me"));
        
        const currentSiteAppId = userData?.siteAppID?.toString();

        useEffect(() => {
            const urlParams = new URLSearchParams(window.location.search);
            const urlSiteAppId = urlParams.get("siteAppId");
            
            // Only show dialog if there's a siteAppId mismatch
            if (urlSiteAppId && currentSiteAppId !== urlSiteAppId) {
                setTargetSiteAppId(urlSiteAppId);
                setShowSwitchDialog(true);
            }
        }, [currentSiteAppId]);

        const switchSiteApp = async () => {
            try {
                await dispatch(loginWithSiteAppId(targetSiteAppId));
            } catch (error) {
                dispatch(showError("Access denied. You do not have permission to access this application."));
            }
        };

        const handleConfirmSwitch = () => {
            if (targetSiteAppId) {
                switchSiteApp();
            }
            setShowSwitchDialog(false);
        };

        const handleCancelSwitch = () => {
            setShowSwitchDialog(false);
            setTargetSiteAppId(null);
            
            // Redirect back to current siteAppId
            const newUrl = new URL(window.location.href);
            newUrl.searchParams.set("siteAppId", currentSiteAppId);
            window.location.href = newUrl.toString();
        };

        return (
            <>
                <ConfirmDialog
                    open={showSwitchDialog}
                    title="Switch Site Application"
                    message="You are about to switch to a different Site Application. Would you like to continue?"
                    confirmButtonText="Switch"
                    onConfirm={handleConfirmSwitch}
                    onCancel={handleCancelSwitch}
                />
                <WrappedComponent {...props} />
            </>
        );
    };
}; 